import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import axios from "axios";
import "./ProjectsPage.css";

// =======================================
// API BASE URL FROM ENV
// =======================================
const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // =======================================
  // FETCH PROJECTS FROM BACKEND
  // =======================================
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/projects`);
        setProjects(response.data);
      } catch (err) {
        console.error("Fetch Projects Error:", err);
        setError("Unable to load projects.");
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <section className="projects-page">
      <div className="projects-container">
        {/* Page Header */}
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="projects-header"
        >
          <h1>Projects & Initiatives</h1>
          <p>
            Alumni-led initiatives driving impact through transparency,
            accountability, and collective support.
          </p>
        </motion.div>

        {/* Loading */}
        {loading && <p className="loading-text">Loading projects...</p>}

        {/* Error */}
        {error && <p className="error-text">{error}</p>}

        {/* Projects Grid */}
        {!loading && !error && (
          <div className="projects-grid">
            {projects.map((project, index) => {
              const percent = project.progress || 0;

              return (
                <motion.article
                  key={project._id}
                  className="project-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.15 }}
                  whileHover={{ y: -8 }}
                >
                  {/* Image */}
                  <div className="project-image-wrapper">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="project-image"
                    />
                    <span
                      className={`project-status ${project.status.toLowerCase()}`}
                    >
                      {project.status}
                    </span>
                  </div>

                  {/* Content */}
                  <div className="project-content">
                    <h2>{project.title}</h2>
                    <p className="project-desc">{project.description}</p>

                    {/* Progress */}
                    <div className="progress-wrapper">
                      <div
                        className="progress-bar"
                        style={{ width: `${percent}%` }}
                      />
                    </div>

                    <div className="project-meta">
                      <span>{percent}% funded</span>
                      <span>
                        ${project.amountRaised.toLocaleString()} /{" "}
                        {project.projectBudget.toLocaleString()}
                      </span>
                    </div>

                    {/* Show Support button only if not completed */}
                    {project.status !== "Completed" && (
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.97 }}
                        className="project-cta"
                      >
                        Support This Project
                      </motion.button>
                    )}
                  </div>
                </motion.article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
